import { Injectable } from '@angular/core';
import { Appointment } from './appointment';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

@Injectable()
export class AppointmentService {

  private baseUrl = environment.apibaseUrl;

  public timezoneoffset = new Date().getTimezoneOffset();

  constructor(private http: HttpClient,
    public datepipe: DatePipe,
  ) { }
  private _appointment: Appointment;
  get AppointmentInfo(): Appointment {
    return this._appointment;
  }
  set AppointmentInfo(appointment: Appointment) {
    this._appointment = appointment;
  }
  public getAppointmentTypes() {
    return this.http.get(this.baseUrl + '/appointment/types');
  }
  public getAppointmentSlots(date, minutes, clinicianId, patientId) {
    return this.http.get(this.baseUrl + '/appointment/slots?dt=' + date + '&minutes=' + minutes + '&clinicianId=' + clinicianId + '&patientId=' + patientId + '&timezoneoffset=' + this.timezoneoffset);
  }
  public getPatients() {
    return this.http.get(this.baseUrl + '/patient/list');
  }

  public getPatientslookup() {
    return this.http.get(this.baseUrl + '/patient/lookuplist');
  }

  public createAppointment(appt) {
    appt.timezoneoffset = this.timezoneoffset;
    const time=new Date().toString().match(/([A-Z]+[\+-][0-9]+.*)/)[1];
    const tz=time.split('(')[1].split(')')[0].replace('Daylight','Standard');
    appt.timezone=tz;

    return this.http.post(this.baseUrl + '/appointment', appt);
  }

  public getAppointments() {
    return this.http.get(this.baseUrl + '/appointment/list?timezoneoffset=' + this.timezoneoffset);
  }

  public getCancelledAppointments() {
    return this.http.get(this.baseUrl + '/appointment/cancelledlist?timezoneoffset=' + this.timezoneoffset);
  }

  public getPastAppointmentList() {

    return this.http.get(this.baseUrl + '/appointment/pastAppointmentlist?timezoneoffset=' + this.timezoneoffset);
  }

  public getAppointment(appointmentId: number) {
    return this.http.get(this.baseUrl + '/appointment/info?appointmentId=' + appointmentId + '&timezoneoffset=' + this.timezoneoffset);
  }

  public cancelAppointment(info) {
    const time=new Date().toString().match(/([A-Z]+[\+-][0-9]+.*)/)[1];
    const tz=time.split('(')[1].split(')')[0].replace('Daylight','Standard');
    info.timezone=tz;
    return this.http.put(this.baseUrl + '/appointment/cancel', info);
  }

  public completeAppointment(info) {
    return this.http.put(this.baseUrl + '/appointment/complete', info);
  }

  public getClinicAppointmentType(clinicId: number) {
    return this.http.get(this.baseUrl + '/appointment/clinic/types?clinicId=' + clinicId);
  }

  public checkIn(appointmentId, latitude, longitude, ip, browserType) {
    return this.http.post(this.baseUrl + '/patient/Checkin?appointmentId=' + appointmentId, {
      Latitude: latitude,
      Longitude: longitude,
      Ip: ip,
      BrowserType: browserType,
      timezoneoffset: this.timezoneoffset
    });
  }

  public getClinicianList(clinicId, patientId) {
    return this.http.get(this.baseUrl + '/appointment/clinician/list?clinicId=' + clinicId + '&patientId=' + patientId);

  }

  getCaseListForPatient() {
    return this.http.get(this.baseUrl + '/appointment/Partcipant/caselist');
  }

  public getCasemgmtAppointments() {
    return this.http.get(this.baseUrl + '/appointment/casemgmtappointment/list');
  }

  getCaseListWithParticipant(appointmentId: number) {
    return this.http.get(this.baseUrl + '/appointment/case/participant/list?id=' + appointmentId);
  }

  public getissueCategoryList() {
    return this.http.get(this.baseUrl + '/appointment/issuecategory/list');
  }

  public getCaseCountyList() {
    return this.http.get(this.baseUrl + '/appointment/caseCountyList');
  }

  public saveNewCase(data: any) {
    return this.http.post(this.baseUrl + '/appointment/saveNewCase', data);
  }

  public GetNewCaseQuestions(data: any) {
    return this.http.post(this.baseUrl + '/appointment/newCaseQuestions', data);
  }

  getSelectedCaseDetails(caseIdList) {
    return this.http.get(this.baseUrl + '/appointment/selectedCases?caseIdList=' + caseIdList);
  }
  GetAppoinmentCanceledOrNot(appoinmentId) {
    return this.http.get(this.baseUrl + '/appointment/appoinmentcanceledornot/' + appoinmentId);


  }

}
